import { Component, Vue } from 'vue-property-decorator'
import { RouterModule } from '@/store/modules/router'
import { SubMenuRightModule } from '@/store/modules/submenu-right'
import subMenu from '@/components/submenu/index.vue'

@Component({
    components: {subMenu}
})
export default class Message extends Vue {
    // ------ 变量 ------

    // ------ 计算属性 ------
    get routerList() {
        return RouterModule.pathChildrens
    }
    get checkNumber() {
        return SubMenuRightModule.messageApproval.checkNumber
    }

    // ------ 生命周期 ------
    created() {
        // this.routerList = RouterModule.pathChildrens
    }

    // ------ 方法 ------
    routerJump(path: string) {
        this.$router.push(path)
    }
    newNotice() {
        SubMenuRightModule.messageNotice.dialogShow = true
    }
    batchApproval() {
        SubMenuRightModule.batchMessageApproval()
    }
}